// extracted by mini-css-extract-plugin
export default {"input":"ura-z","button":"vra-z","selected":"wra-z","unavailable":"xra-z","image":"yra-z"};